import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import PublicAppointmentHistoryList from './components/PublicAppointmentHistoryList';

const { Cell } = ResponsiveGrid;

const PublicAppointmentHomepage = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="公設歷史紀錄"
        // description="公設預約清單"
        breadcrumbs={[
          {
            name: '公設預約',
          },
          {
            name: '公設歷史紀錄',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <PublicAppointmentHistoryList />
    </Cell>
  </ResponsiveGrid>
);

export default PublicAppointmentHomepage;
